import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { App } from './App/App';
//import { ConfigProvider } from 'antd';
import reportWebVitals from './reportWebVitals';
import "antd/dist/antd.css";
import './contents/myStyle.css'
import './contents/emersun.css'
ReactDOM.render(
  <Provider store={store}>
    {/* <ConfigProvider direction="rtl"> */}
      <App />
    {/* </ConfigProvider> */}

  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
